<template>
    <div class="tag-status">
        <CompassTag :color="information.color" :size="size" :icon="information.icon">
            {{ label }}
        </CompassTag>
    </div>
</template>
<script>
import { allStatus, deliveryStatus, incomingPurDocStatus, promotionStatus } from 'Dictionaries/statusColors';

export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['small', 'medium', 'large'].includes(value),
        },
        type: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'delivery', 'incomingPurDoc', 'promotion'].includes(value),
        },
    },
    computed: {
        information() {
            const status = this.id.toLowerCase();

            switch (this.type) {
                case 'delivery':
                    return deliveryStatus[status];
                case 'incomingPurDoc':
                    return incomingPurDocStatus[status];
                case 'promotion':
                    return promotionStatus[status];
                default:
                    return allStatus[status];
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.tag-status {
    align-items: center;
    display: flex;
    height: 100%;
}
</style>
